// extracted by mini-css-extract-plugin
export var categoriesList = "categories-list-module--categories-list--vQN98";
export var categoriesListWrapper = "categories-list-module--categories-list-wrapper--IHCNw";
export var categoryShowAllLink = "categories-list-module--category-show-all-link--lNTwu";